const ConstituencyLabel = ({ hoverConstituency, outlets, isHex, mousePos, boundaryType = 'constituency' }) => {
    const idKey = boundaryType === 'constituency' ? 'PCON24CD' : 'LAD24CD';
    const nameKey = boundaryType === 'constituency' ? 'PCON24NM' : 'LAD24NM';
    const coverageKey = boundaryType === 'constituency' ? 'COVERAGE_CONSTITUENCY' : 'COVERAGE_LAD';

    const outletsInArea = outlets.filter(outlet => outlet[coverageKey]?.includes(hoverConstituency[idKey]));

    const mediaCounts = {};
    outletsInArea.forEach(outlet => {
        const type = outlet.MEDIA_TYPE || 'Other';
        mediaCounts[type] = (mediaCounts[type] || 0) + 1;
    });

    return (
        <div
            style={{
                position: 'absolute',
                bottom: '1rem',
                left: '1rem',
                zIndex: 2000,
                pointerEvents: 'none',
                animation: 'fadeIn 0.15s ease-out'
            }}
        >
            <div className='location-label-container'>
                <div className='location-label-header'>
                    <p className='location-label-title'>{hoverConstituency[nameKey]}</p>
                    <p style={{ fontSize: '0.7rem', opacity: 0.8, marginTop: '2px' }}>
                        {boundaryType === 'constituency' ? 'Constituency' : 'Local Authority'}
                    </p>
                </div>
                <div className='location-label-body'>
                    {Object.entries(mediaCounts).map(([type, count]) => (
                        <div key={type} className='location-label-row'>
                            <span className='label-type'>{type}</span>
                            <span className='label-count'>{count}</span>
                        </div>
                    ))}
                    <div className='location-label-row total'>
                        <span className='label-type'>Total titles</span>
                        <span className='label-count'>{outletsInArea.length}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConstituencyLabel;
